import { DialogActions, DialogTitle, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState } from 'src/store';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const QualityControl = (props: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const { checkPermission } = usePermissionWrapper();
  const [checked, setChecked] = React.useState(false);
  const [show, setShow] = React.useState(true);
  const [comments, setComments] = React.useState(documentDetail.data[0]?.tmf_doc_viewer_qc_issue_comments);
  const [issue, setIssue] = React.useState('');

  const handleChange = (event: SelectChangeEvent) => {
    setIssue(event.target.value);
  };

  const handleChangeCheck = () => {
    const temp = checked ? false : true;
    setChecked(temp);
    setShow(false);
  };

  const handleDocumentName = (e: any) => {
    setComments(e.target.value.trimLeft());
  };

  const handleUploadFile = (checked: boolean, comments: string, issue: any) => {
    setShow(true);
  };

  return (
    <div className="quallityControl-modal">
      <PopupComponent aria-labelledby="customized-dialog-title" open={props.open} className="quallityControl-modal">
        <DialogTitle id="alert-dialog-title">Quality Control</DialogTitle>
        <DialogContent dividers className="quallityControl-modalcontent">
          <Grid container>
            <Grid md={12}>
              <FormControl variant="standard" sx={{ minWidth: 120 }}>
                <InputLabel id="demo-simple-select-standard-label">QC Issue Type</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  defaultValue={documentDetail.data[0]?.tmf_doc_viewer_qc_issue_type}
                  value={issue ? issue : documentDetail.data[0]?.tmf_doc_viewer_qc_issue_type}
                  onChange={handleChange}
                  disabled={checkPermission('update_qc_details')}
                >
                  <MenuItem value="Metadata issue">Metadata issue</MenuItem>
                  <MenuItem value="Duplicate document">Duplicate document</MenuItem>
                  <MenuItem value="Translation required">Translation required</MenuItem>
                  <MenuItem value="Certification">Certification</MenuItem>
                  <MenuItem value="Signature issue">Signature issue</MenuItem>
                  <MenuItem value="Illegible">Illegible</MenuItem>
                  <MenuItem value="Incomplete document">Incomplete document</MenuItem>
                  <MenuItem value="Quality of document">Quality of document</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid md={12} sx={{ pt: 0.5 }}>
              <TextField
                id="standard-basic"
                label="QC Issue Comments"
                variant="standard"
                defaultValue={documentDetail.data[0]?.tmf_doc_viewer_qc_issue_comments}
                value={comments}
                inputProps={{
                  maxLength: 100
                }}
                onChange={e => handleDocumentName(e)}
                disabled={checkPermission('update_qc_details')}
              />
            </Grid>

            <Grid md={12}>
              <h5>Certified Copy</h5>
              <p>Verify if the following information according to the document is correct:</p>
              <ul>
                <li>All pages of the document are present</li>
                <li>There are no blank pages present</li>
                <li>Pages are in the correct order</li>
                <li>All content in the margins is viewable</li>
                <li>All wet-ink signatures and dates are viewable</li>
                <li>The image/uploaded document is clear</li>
                <li>Document is in the final version</li>
              </ul>
            </Grid>

            <Grid md={12}>
              <FormGroup>
                <FormControlLabel
                  sx={{ pl: 2.5 }}
                  control={<Checkbox checked={checked} onChange={handleChangeCheck} />}
                  label="I have verified the following information above"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid item md={12} className="button-actions">
            <Grid container spacing={2}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack direction="row" spacing={2}>
                  <Button className="grey-btn" onClick={props.handleClose}>
                    Close
                  </Button>
                  <Button onClick={() => handleUploadFile(checked, comments, issue)} disabled={show}>
                    Save
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};

export default React.memo(QualityControl);
